module.exports = __webpack_public_path__ + "static/media/tailwind.de36818b.svg";